// extracted by css-extract-rspack-plugin
export default {"Root":"cTAIi","AggregationName":"MJUEj","RemoveIcon":"y_a2S"};